import theme from "../../theme";
import type { RegistrationPageStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<RegistrationPageStyles, SxProps<Theme>> => {
  return {
    paper: {
      m: theme.spacing(8, 4),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
    },

    error: {
      color: "#f44336",
      mt: theme.spacing(3),
    },

    box: { justifyContent: "center" },
  };
};

export default getStyles;
